import { render, staticRenderFns } from "./RequestPasswordResetComplete.vue?vue&type=template&id=e08988d8&scoped=true&"
import script from "./RequestPasswordResetComplete.vue?vue&type=script&lang=js&"
export * from "./RequestPasswordResetComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08988d8",
  null
  
)

export default component.exports